/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

// Ant Design
import {
  Row,
  Button,
  Divider,
  Typography,
  Col,
  Select,
  Table,
  Tag,
  Form,
  message,
} from "antd";

// Custom Components
import TypeBasedInput from "./TypeBasedInput";

// Constants
import {
  dataTypeValues,
  matchOptions,
} from "./../../../../../core/utils/constants/demographicConstants";
import { useAudienceBuilderContext } from "../../context/AudienceBuilderContext";

const { Text } = Typography;

const GenericMetric = props => {
  const {
    loading,
    updateAudienceMetrics,
    removeAudienceMetric,
    metric,
  } = props;

  const {
    inputValue,
    setInputValue,
    matchCharacteristics,
    setMatchCharacteristics,
    metricValue,
    setMetricValue,
  } = useAudienceBuilderContext();

  const [definedValues, setDefinedValues] = useState([]);

  const handleMenuClick = e => {
    setMatchCharacteristics(e);
  };

  const getValuesByKey = key => {
    if (dataTypeValues.hasOwnProperty(key)) {
      return dataTypeValues[key].values;
    } else {
      return [];
    }
  };

  const getDefinedValues = metric => {
    const definedValues = getValuesByKey(metric.key);
    setDefinedValues(definedValues);
  };

  const validateInput = () => {
    if (matchCharacteristics === 0) {
      message.warning("Please select a match characteristic");
      return false;
    }

    if (
      metric.type === "Number" &&
      (metricValue == null || metricValue.value == null)
    ) {
      message.warning("Please enter a value");
      return false;
    }

    if (
      metric.type === "String" &&
      (metricValue == null ||
        metricValue.value == null ||
        metricValue.value.trim() === "")
    ) {
      message.warning("Please enter a value");
      return false;
    }

    if (
      metric.type === "Date" &&
      (metricValue == null ||
        metricValue.value == null ||
        metricValue.value === "")
    ) {
      message.warning("Please enter a value");
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (metric) {
      getDefinedValues(metric);
    }
  }, [metric]);

  useEffect(() => {
    if (metricValue) return;

    switch (metric.type) {
      case "Boolean":
        setInputValue(false);
        setMetricValue({
          value: 0,
          key: metric.key,
          name: metric.name,
          dataType: metric.type,
        });
        setMatchCharacteristics("=");
        break;
      case "Number":
        setInputValue(null);
        setMetricValue({
          value: 0,
          key: metric.key,
          name: metric.name,
          dataType: metric.type,
        });
        break;
      default:
        setInputValue(null);
        setMetricValue(null);
        setMatchCharacteristics(null);
    }
  }, [metric.type]);

  return (
    <>
      <div style={{ padding: "15px" }}>
        <Text style={{ fontSize: "20px" }}>
          {metric ? metric.name : "Metric"}
        </Text>

        <Row style={{ padding: "10px" }}>
          <Row style={{ height: "50px", width: "100%" }} align="middle">
            <Col span={12} style={{ paddingTop: "11px" }}>
              <p>{metric.name}</p>
            </Col>

            <Col span={12}>
              <TypeBasedInput
                dataType={metric.type}
                metric={metric}
                inputValue={inputValue}
                setInputValue={setInputValue}
                setMetricValue={setMetricValue}
              />
            </Col>
          </Row>
        </Row>

        {definedValues.length > 0 && (
          <Row>
            <Col span={24} style={{ height: "300px", overflow: "scroll" }}>
              <Tag color="blue" style={{ marginBottom: "1em" }}>
                Enter the code in the field
              </Tag>
              <Table
                columns={[
                  {
                    title: "Code",
                    dataIndex: "label",
                  },
                  {
                    title: "Description",
                    dataIndex: "value",
                  },
                ]}
                dataSource={definedValues.map((item, index) => ({
                  ...item,
                  key: index.toString(),
                }))}
                size="small"
                pagination={false}
              />
            </Col>
          </Row>
        )}

        <Divider />
        <Row>
          <Col span={24}>
            <Text>Add People Who</Text>
            <div style={{ width: "100%", marginTop: "0.5em" }}>
              <Select
                defaultValue=""
                loading={loading}
                value={matchCharacteristics}
                disabled={loading || metric.type === "Boolean"}
                style={{ width: "100%" }}
                onChange={(_, val) => {
                  handleMenuClick(val.value);
                }}
                options={matchOptions}
              />
            </div>
          </Col>
        </Row>
        <Row justify="end" style={{ marginTop: "0.5em" }} gutter={4}>
          <Col>
            <Button
              loading={loading}
              disabled={loading}
              onClick={() => removeAudienceMetric(metric)}
            >
              Remove
            </Button>
          </Col>
          <Col>
            <Form.Item>
              <Button
                loading={loading}
                disabled={
                  loading ||
                  (matchCharacteristics == null && metric.type !== "Boolean")
                }
                onClick={async () => {
                  if (validateInput()) {
                    await updateAudienceMetrics({
                      matchCharacteristics,
                      metricValue,
                    });
                  }
                }}
              >
                Update Audience
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default GenericMetric;
